/** Session-local invalidation only; this module never grants read permission. */
let epoch = 0
let scope: string | null = null
const listeners = new Set<() => void>()
export const visibilityEpoch = () => epoch
export function resetVisibility() {
  epoch += 1
  scope = null
  listeners.forEach((listener) => listener())
}
export function acceptVisibilityScope(next: string) {
  if (scope !== null && scope !== next) {
    resetVisibility()
    scope = next
    throw new Error('Dashboard visibility changed; previous views discarded')
  }
  scope = next
}
export function subscribeVisibility(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/**
 * Watches the signed-in user's role for a change. The first answer is only the
 * baseline: the views already loaded were each authorized by the server, and
 * read views carry their own visibility scope (`acceptVisibilityScope`), so
 * discarding them here would just load every page twice. Each later change of
 * role, including losing it, calls `onChange`.
 */
export function roleChangeObserver(onChange: () => void) {
  const unresolved = Symbol('unresolved')
  let observed: unknown = unresolved
  return (role: unknown) => {
    if (observed === unresolved) {
      observed = role
      return
    }
    if (role !== observed) {
      observed = role
      onChange()
    }
  }
}
